import Heading from '../Typography/Heading';

export default function CardTitle({ children }){
	return (
		<Heading level={3} className='title' weight={800}>
			{children}
		</Heading>
	);
}

